export const BUCKET_NAME_PATTERN = /^[a-z0-9-]+$/;

export const normalizeBucketName = (value: string) => value.trim().toLowerCase();

export const getBucketNameValidationError = (value: string, existingBucketNames: string[]) => {
  const trimmedValue = value.trim();

  if (!trimmedValue) {
    return null;
  }

  if (!BUCKET_NAME_PATTERN.test(trimmedValue)) {
    return "modals.validation.bucketNamePattern";
  }

  const normalizedExistingBucketNames = new Set(existingBucketNames.map(normalizeBucketName));
  const normalizedValue = normalizeBucketName(trimmedValue);

  if (normalizedExistingBucketNames.has(normalizedValue)) {
    return "modals.validation.bucketNameUnique";
  }

  return null;
};
